var render = function render(_c,_vm){return _c('div',{staticClass:"faces mt-2 mb-1",class:{ disabled: _vm.props.disabled }},[_vm._l((5),function(n){return _c('img',{key:n,staticClass:"option mr-1",class:{ selected: _vm.props.value === n },attrs:{"src":_vm.props.faces[n - 1]},on:{"click":function($event){return _vm.listeners.input(n)}}})}),_vm._t("default",null,{"ratingCount":5})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }